import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@store/theme/common/design";
import { css } from "styled-components";

export const inputLabelStyles = () => {
    return css`
        color: ${getColor("text.dark")};
        font-size: ${TYPOGRAPHY.size.small};
        font-weight: ${TYPOGRAPHY.weight.bold};
    `;
};

export const inputStyles = () => {
    return css`
        border-width: 2px;
        border-radius: 2px;
        vertical-align: top;
        &:disabled {
            border-color: ${getColor("common.border")};
            background-color: ${getColor(
                "common.disabledLighter",
            )} !important; /* We don't want to exclude dates picker with this selector input:not(.react-datetime-picker__inputGroup__input) */
        }
    `;
};
